import {
  AbstractListener,
  GameStateMachineNotifierComponent,
  GameStateMachineStates,
  ORIENTATION_HANDLER_COMPONENT_TOKEN,
  ResourcesComponent,
  T_GameStateMachineNotifierComponent,
  RESOURCES_COMPONENT_TOKEN,
} from '@cgs/machines';
import { Container, SceneObject } from '@cgs/wge';
import { CorsicaOrientationHandlerComponent } from './resize-handler/corsica-orientation-handler.component';

enum SceneStates {
  Default = 'default',
  FreeSpins = 'free_game',
  FreeSpinsLabels = 'fs',
}

export const CORSICA_BACKGROUND_COMPONENT_TOKEN = Symbol('CorsicaBackgroundComponent');

export class CorsicaBackgroundComponent implements AbstractListener {
  private _backgroundModesScene: SceneObject | null;
  private _freeSpinsLabels: SceneObject[] | null;

  private readonly orientationHandler: CorsicaOrientationHandlerComponent;

  constructor(container: Container) {
    const resourceComponent: ResourcesComponent =
      container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    this._backgroundModesScene = resourceComponent.bg;

    this._freeSpinsLabels = resourceComponent.slot.findAllById('fs_tooltips');

    const notifierComponent = container.resolve<GameStateMachineNotifierComponent>(
      T_GameStateMachineNotifierComponent
    );
    notifierComponent.notifier.addListener(this);

    this.orientationHandler = container.resolve<CorsicaOrientationHandlerComponent>(
      ORIENTATION_HANDLER_COMPONENT_TOKEN
    );
  }

  public onStateEntered(slotState: string): void {
    switch (slotState) {
      case GameStateMachineStates.FreeSpinRecovery:
        this.setState(SceneStates.FreeSpins);
        this.setFreeSpinsLabels(SceneStates.FreeSpinsLabels);
        this.orientationHandler.update();
        break;
    }
  }

  public onStateExited(slotState: string): void {
    switch (slotState) {
      case GameStateMachineStates.EndBonus:
        this.setState(SceneStates.FreeSpins);
        this.setFreeSpinsLabels(SceneStates.FreeSpinsLabels);
        this.orientationHandler.update();
        break;
      case GameStateMachineStates.EndOfFreeSpinsPopup:
        this.setState(SceneStates.Default);
        this.setFreeSpinsLabels(SceneStates.Default);
        this.orientationHandler.update();
        break;
    }
  }

  private setFreeSpinsLabels(state: SceneStates): void {
    if (this._freeSpinsLabels) {
      for (const label of this._freeSpinsLabels) {
        label.stateMachine?.switchToState(state);
      }
    }
  }

  private setState(state: SceneStates): void {
    this._backgroundModesScene?.stateMachine?.switchToState(state);
  }
}
